import { InputError } from 'components/Form/FormCommomStyle/FormCommomStyle'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  width: 80%;

  .new-colaborator-container {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0px;
    width: 100%;
    gap: 24px;
  }

  .new-colaborator-container-access {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0px;
    width: 70%;
    gap: 24px;
    position: relative;
  }

  .new-colaborator-title {
    color: #000;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media only screen and (min-width: 1441px) {
      font-size: 18px;
    }
  }
  .togle-container {
    max-width: fit-content;
    margin-top: 20px;
  }

  .new-colaborator-subtitle-img {
    width: 16px;
    height: 16px;
  }

  .new-colaborator-subtitle {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #070707;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
    @media only screen and (min-width: 1441px) {
      font-size: 15px;
    }
  }
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
  .selected-client-name {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    width: 252px;
    padding: 13px;
    background-color: rgb(204, 204, 204);
    border-radius: 5px;
  }

  .selected-cliente-trash {
    width: 19px;
    margin-left: 20px;
    cursor: pointer;
  }
`

export const ErrorContainer = styled.div`
  position: absolute;
  bottom: 16px;
  width: 100%;
`
interface IStyleProps {
  error?: string | undefined
  ['data-testid']: string
}
export const ErrorText = styled(InputError)<IStyleProps>``
